/** Búsqueda en modales de selección de paciente/empresa (facturación, presupuesto, RIPS). */

export const normalizarParaBusqueda = (texto) => {
    if (texto == null || texto === '') return '';
    return String(texto)
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
};

export const coincideTextoBusqueda = (texto, filtro) => {
    const termino = normalizarParaBusqueda(filtro);
    if (!termino) return true;
    const base = normalizarParaBusqueda(texto);
    if (!base) return false;
    if (base.includes(termino)) return true;
    const palabras = termino.split(' ').filter(Boolean);
    return palabras.every((palabra) => base.includes(palabra));
};

export const getNombreClienteFacturacion = (paciente) => {
    const nombrePersona = `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim();
    return nombrePersona || paciente.razon_social || paciente.nombre_empresa || paciente.nombre_comercial || paciente.nombre || 'Sin nombre';
};

export const filtrarPacientesParaModal = (pacientes, filtroBusqueda) => {
    const filtro = (filtroBusqueda || '').trim();
    if (!filtro) return pacientes;

    const documentoFiltro = normalizarParaBusqueda(filtro).replace(/\s/g, '');

    return pacientes.filter((paciente) => {
        const nombreMostrar = getNombreClienteFacturacion(paciente);
        const coincideNombre = coincideTextoBusqueda(nombreMostrar, filtro);

        const numeroDocumento = normalizarParaBusqueda(paciente.numero_documento || '').replace(/\s/g, '');
        const coincideDocumento = documentoFiltro !== '' && numeroDocumento.includes(documentoFiltro);

        const textosEmpresa = [
            paciente.razon_social,
            paciente.nombre_empresa,
            paciente.nombre_comercial,
            paciente.nombre,
        ]
            .filter(Boolean)
            .join(' ');
        const coincideEmpresa = textosEmpresa
            ? coincideTextoBusqueda(textosEmpresa, filtro)
            : false;

        return coincideNombre || coincideDocumento || coincideEmpresa;
    });
};

/** Pacientes naturales + empresas (misma carga que CrearFactura). */
export const combinarPacientesYEmpresas = (respPacientes, respEmpresas) => {
    const listaPacientes = Array.isArray(respPacientes?.data) ? respPacientes.data : (Array.isArray(respPacientes) ? respPacientes : []);
    const listaEmpresas = Array.isArray(respEmpresas?.data) ? respEmpresas.data : (Array.isArray(respEmpresas) ? respEmpresas : []);
    const combinados = [...listaPacientes, ...listaEmpresas];
    return Array.from(new Map(combinados.map((item) => [item.id, item])).values());
};
